<template>
  <div class="ten-cascader-menu">
    <h5
      class="ten-cascader-menu__title"
      v-if="title"
    >
      {{ title }}
    </h5>
    <ten-options
      ref="options"
      :show-checkbox="_showCheckbox"
      :show-radio="_showRadio"
      :empty="options.length === 0"
      :loading="loading"
    >
      <ten-option
        ref="optionItems"
        :key="model._key"
        v-for="model in options"
        :show-checkbox="shouldMultipleCheck(model)"
        :active="isExpanded(model)"
        :selected="isSelected(model)"
        :disabled="model.data.disabled"
        :indeterminate="model.status.selected === 2"
        :suffix-icon="getSuffixIcon(model)"
        :loading="model.loading"
        @optionFocus="onItemFocus(model)"
        @mouseover="onItemMouseover(model)"
        @optionClick="onItemClick(model)"
        @select="onItemSelect(model)"
        @optionKeyCommand="type => onOptionKeyCommand(model, type)"
      >
        <render-cell :render="getRenderOptionFunction(model)" />
      </ten-option>
      <v-nodes slot="emptyTip" :vnodes="_renderEmptyTip" />
    </ten-options>
  </div>
</template>
<script>
import TenOptions from './options';
import TenOption from './option';
import VNodes from '../vnodes';
import RenderCell from '../render-cell';

const name = 'ten-cascader-menu';
export default {
  name,
  components: { TenOptions, TenOption, VNodes, RenderCell },
  inject: ['tenCascaderPanel'],
  props: {
    options: Array, // treeNodeModels
    title: String,
    index: {
      type: Number,
      default: 0,
    },
    isFilterMode: Boolean,
    renderLabel: Function,
    loading: Boolean,
  },
  computed: {
    _multiple() {
      return this.tenCascaderPanel.multiple;
    },
    _showCheckbox() {
      return this.tenCascaderPanel.multiple;
    },
    _showRadio() {
      return this.tenCascaderPanel.independent && !this.isFilterMode;
    },
    _renderEmptyTip() {
      return this.tenCascaderPanel.renderEmptyTip();
    },
  },
  methods: {
    isExpanded(model) {
      return this.tenCascaderPanel.expandedNodes.indexOf(model) > -1;
    },
    isSelected(model) {
      if (this._multiple || this.tenCascaderPanel.independent) {
        return model.selected === 1;
      }
      return model.isLeaf && model.selected === 1;
    },
    getLabel(model) {
      if (this.renderLabel) {
        return this.renderLabel(model);
      }
      return model.data[this.tenCascaderPanel.optionLabel];
    },
    getRenderOptionFunction(model) {
      return h => this.tenCascaderPanel.renderOptionContent(h, model);
    },
    getSuffixIcon(model) {
      if (this.isFilterMode) {
        return '';
      }
      if (!model.isLeaf) {
        return model.loading ? 'loading_gradient' : 'right';
      }
      return '';
    },
    select(model) {
      if (model.data.disabled) {
        return;
      }
      // eslint-disable-next-line
      const selected = this.tenCascaderPanel.multiple
        ? model.status.selected === 1
          ? 0
          : 1
        : 1;
      this.tenCascaderPanel.onNodeSelect(model, selected);
    },
    expand(model) {
      if (model.data.disabled) {
        return;
      }
      if (this.isFilterMode) {
        return;
      }
      this.tenCascaderPanel.onNodeExpand(model, this.index);
    },
    focus(index) {
      let focusIndex;
      if (typeof index !== 'undefined') {
        focusIndex = index;
      } else if (this.$refs.options.focusIndex === -1) {
        focusIndex = 0;
      }
      this.$refs.options.focus(focusIndex);
    },
    blur() {
      this.$refs.options.blur();
    },
    onItemFocus(model) {
      this.expand(model);
    },
    onItemClick(model) {
      if (this.tenCascaderPanel.expandTrigger === 'click') {
        this.expand(model);
      }

      if (model.isLeaf || this.isFilterMode) {
        this.select(model);
      }
    },
    onItemMouseover(model) {
      if (this.tenCascaderPanel.expandTrigger === 'hover') {
        this.expand(model);
      }
    },
    onItemSelect(model) {
      this.select(model);
      if (!model.isLeaf) {
        this.expand(model);
      }
    },
    onOptionKeyCommand(model, type) {
      switch (type) {
        case 'enter':
          if (model.isLeaf || this._multiple) {
            this.select(model);
          }
          break;
        case 'left':
          this.$emit('menuBlur', 'left');
          break;
        case 'right':
          this.$emit('menuBlur', 'right');
          break;
      }
    },
    shouldMultipleCheck(model) {
      if (!this._multiple) return false;

      const { onlyLeafSelectable } = this.tenCascaderPanel;
      return onlyLeafSelectable ? model.isLeaf : true;
    },
  },
};
</script>
